import React, { useState, useEffect, useRef } from "react";
import { basename, dirname } from '../../utils/path';
import { createURI } from '../../shared/utils/URI';
import { LocalFileSystemID, MirrorEventType } from '../../shared/types';
import { command$ } from '../../observables/command';
import { CommandID } from '../../commands';
import { useEffectOnUpdate, useSubscribe } from '../../hooks';
import { remove } from 'ramda';
import MissingDir from './MissingDir';
import { Spinner, Split } from '../../ui/components';
import CreateMirrorSync from '../../plugins/mirror/Create/Create';
import MirrorsList from '../../plugins/mirror/List/List';
import { events$ } from '../../plugins/mirror/events';
export default function LocalPane({ localPath, remotePath, connection, onSettingsChange, sid, missingTarget, setMissingTarget, tryDir, setSync, filter, children }) {
    const [showCreateMirrorSync, setShowCreateMirrorSync] = useState(false);
    const [mirrors, setMirrors] = useState([]);
    const mirrorsChanged = useRef(false);
    useSubscribe(() => command$.subscribe(cmd => {
        switch (cmd.id) {
            case CommandID.MirrorSync:
                setShowCreateMirrorSync(true);
                break;
        }
    }), [localPath, remotePath]);
    useEffect(() => {
        setMirrors([]);
    }, [connection?.id]);
    useSubscribe(() => events$
        .subscribe(event => {
        if (event.type == MirrorEventType.Create
            && event.sid == sid) {
            setMirrors(mirrors => [
                ...mirrors,
                {
                    id: event.id,
                    local: event.setting.local,
                    remote: event.setting.remote,
                    recursive: event.setting.recursive,
                    del: event.setting.del,
                    filter: event.setting.filter
                }
            ]);
        }
    }), [sid]);
    useEffectOnUpdate(() => {
        if (mirrorsChanged.current == true) {
            mirrorsChanged.current = false;
            if (sid && connection?.file) {
                onSettingsChange(mirrors);
            }
        }
    }, [mirrors]);
    const createMirror = (conf) => {
        if (!connection?.id || !sid) {
            return;
        }
        const remote = createURI(connection.id, remotePath);
        window.f5.mirror(localPath, remote, sid, conf.recursive, conf.del, (filter
            && (filter.text.trim().length > 0
                || filter.hidden === true
                || filter.temporary === true
                || filter.uncommited === true
                || filter.ignored === true)) ? filter : undefined);
        mirrorsChanged.current = true;
    };
    const onMirrorDelete = (id) => {
        const i = mirrors.findIndex(m => m.id == id);
        if (i >= 0) {
            setMirrors(remove(i, 1, mirrors));
            window.f5.unmirror(id);
            mirrorsChanged.current = true;
        }
    };
    const inner = connection?.id && mirrors.length
        ? React.createElement(Split, { vertical: true, initial: 80, left: children, right: React.createElement(MirrorsList, { mirrors: mirrors, onDelete: onMirrorDelete }) })
        : children;
    return localPath
        ? (missingTarget == 'local'
            ? React.createElement(MissingDir, { path: localPath, onClose: async (create) => {
                    if (create) {
                        await window.f5.mkdir(basename(tryDir), createURI(LocalFileSystemID, dirname(tryDir)));
                        setMissingTarget(undefined);
                    }
                    else {
                        setMissingTarget(undefined);
                        setSync(false);
                    }
                } })
            : React.createElement(React.Fragment, null,
                inner,
                showCreateMirrorSync &&
                    React.createElement(CreateMirrorSync, { localPath: localPath, remotePath: remotePath, filter: filter, onClose: conf => {
                            setShowCreateMirrorSync(false);
                            conf && createMirror(conf);
                        } })))
        : React.createElement("div", { className: "fill-center" },
            React.createElement(Spinner, { radius: "2em" }));
}
